import { ConfirmationModalFooter } from '@/components/ConfirmationModal/Base/Footer';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { ButtonV2Props, Modal } from '@moneyforward/ap-frontend-components';
import { FC, memo, useCallback, useMemo, useState } from 'react';
import { Contents } from './Contents';

type ConfirmEnableOfficeSettingModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
};

export const ConfirmEnableOfficeSettingModal: FC<ConfirmEnableOfficeSettingModalProps> =
  memo(({ open, onClose, onConfirm, isPending }) => {
    const containerRef = useGlobalContainerRef();
    const { t } = useTranslation();
    const [agreedToTerms, setAgreedToTerms] = useState(false);

    const handleClose = useCallback(() => {
      setAgreedToTerms(false);
      onClose();
    }, [onClose]);

    const cancelButtonProps: ButtonV2Props = useMemo(
      () => ({
        isSecondary: true,
        onClick: handleClose,
        size: 'sm',
        children: t('cancel'),
        isDisabled: isPending,
      }),
      [handleClose, t, isPending]
    );

    const okButtonProps: ButtonV2Props = useMemo(
      () => ({
        color: 'primary',
        onClick: onConfirm,
        size: 'sm',
        children: t('use_start'),
        isDisabled: !agreedToTerms || isPending,
        isLoading: isPending,
        isTransparent: isPending,
        style: {
          minWidth: '90px',
        },
      }),
      [onConfirm, agreedToTerms, t, isPending]
    );

    return (
      <Modal
        open={open}
        onClose={handleClose}
        size='md'
        title={t('ai_agents_setting_main_setting_confirm_enable_start_title')}
        getContainer={containerRef}
        mask
        footer={
          <ConfirmationModalFooter
            cancelButton={cancelButtonProps}
            okButton={okButtonProps}
          />
        }
      >
        <Contents
          agreedToTerms={agreedToTerms}
          onAgreedToTermsChange={setAgreedToTerms}
        />
      </Modal>
    );
  });

ConfirmEnableOfficeSettingModal.displayName = 'ConfirmEnableOfficeSettingModal';
